import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import Alpine from 'alpinejs';
import axios from 'axios';
import { screens } from '../../../../config/breakpoints.js';

const desktop = screens.desktop.replace(/[^\d.-]/g, '');
const tablet = screens.tablet.replace(/[^\d.-]/g, '');
const mql = window.matchMedia(`(max-width: ${desktop}px)`);

mql.onchange = e => {
  if (e.matches) {
    /* the viewport is less than desktop */
    initSplide();
  }
};

Alpine.data('magazinTeaser', () => ({
  magazinItems: [],
  filterItems: [],
  activeFilterValue: '',

  init() {
    this.getMagazinItems();
  },

  getMagazinItems() {
    const numberItems = window.innerWidth >= desktop ? 3 : 9;
    const magazinTeaser = this.$refs.magazinTeaser;
    const { url } = magazinTeaser.dataset;
    axios
      .get(url, {
        params: {
          numberItems,
          // filterValue: this.activeFilterValue
        },
      })
      .then(response => {
        const { magazinItems, filterItems } = response.data;
        this.magazinItems.push(...magazinItems);
        this.filterItems = filterItems;
      })
      .then(() => {
        initSplide();
      });
  },

  loadMoreItems() {
    this.getMagazinItems();
  },

  resetItems() {
    this.magazinItems.splice(3, Infinity);
  },
}));

const initSplide = () => {
  if (window.innerWidth < desktop) {
    const splideContainer = document.querySelector('.magazin-teaser .splide');
    if (splideContainer) {
      const options = {
        pagination: false,
        arrows: false,
        fixedWidth: '65%',
        mediaQuery: 'min',
        gap: '20px',
        breakpoints: {
          [desktop]: {
            destroy: 'completely',
          },
          [tablet]: {
            fixedWidth: '40%',
          },
        },
      };
      const splide = new Splide(splideContainer, options);
      splide.mount();
    }
  }
};
